module.exports = __webpack_public_path__ + "static/media/landing.6b319e2f.png";